/**
 * @generated SignedSource<<ec3cf66e2ad1a21c601e6164e7c105ab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProductType = "community_event" | "course" | "membership_plan" | "pathway" | "%future added value";
export type ProductRegistrationSuccessStepQuery$variables = {
  id: string;
};
export type ProductRegistrationSuccessStepQuery$data = {
  readonly product: {
    readonly cover?: string;
    readonly name?: string;
    readonly slug?: string;
    readonly type?: ProductType;
    readonly viewerMembership?: {
      readonly id: string;
      readonly organizationMembership: {
        readonly hasSeenOnboarding: boolean;
        readonly id: string;
        readonly viewerShouldCompleteMemberOnboarding: boolean;
      };
    } | null;
  } | null;
};
export type ProductRegistrationSuccessStepQuery = {
  response: ProductRegistrationSuccessStepQuery$data;
  variables: ProductRegistrationSuccessStepQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cover",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductMembership",
      "kind": "LinkedField",
      "name": "viewerMembership",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "OrganizationMembership",
          "kind": "LinkedField",
          "name": "organizationMembership",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasSeenOnboarding",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerShouldCompleteMemberOnboarding",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductRegistrationSuccessStepQuery",
    "selections": [
      {
        "alias": "product",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProductRegistrationSuccessStepQuery",
    "selections": [
      {
        "alias": "product",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v3/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e55ab00f05113311261fa2ba1d7233a2",
    "id": null,
    "metadata": {},
    "name": "ProductRegistrationSuccessStepQuery",
    "operationKind": "query",
    "text": "query ProductRegistrationSuccessStepQuery(\n  $id: ID!\n) {\n  product: node(id: $id) {\n    __typename\n    ... on Product {\n      cover\n      name\n      type\n      slug\n      viewerMembership {\n        id\n        organizationMembership {\n          id\n          hasSeenOnboarding\n          viewerShouldCompleteMemberOnboarding\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8c1e639bc274b8c5657e06223d5e9d3e";

export default node;
